/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsuarioDto } from '../../models/usuario-dto';

export interface DoctoresPacientesControllerObtenerInfoPaciente$Params {

/**
 * UUID del paciente
 */
  uuidPaciente: string;
}

export function doctoresPacientesControllerObtenerInfoPaciente(http: HttpClient, rootUrl: string, params: DoctoresPacientesControllerObtenerInfoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<UsuarioDto>> {
  const rb = new RequestBuilder(rootUrl, doctoresPacientesControllerObtenerInfoPaciente.PATH, 'get');
  if (params) {
    rb.path('uuidPaciente', params.uuidPaciente, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsuarioDto>;
    })
  );
}

doctoresPacientesControllerObtenerInfoPaciente.PATH = '/api/doctor-pacientes/info-paciente/{uuidPaciente}';
